import { ReactNode, useState } from 'react'
import styled from 'styled-components'

import { IconLeft } from 'components/Icons/IconLeft'
import { IconRadioButtonActive } from 'components/Icons/IconRadioButtonActive'
import { IconRadioButtonNotActive } from 'components/Icons/IconRadioButtonNotActive'
import { IconRight } from 'components/Icons/IconRight'

const CarouselContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  margin: 16px 0;
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    display: none;
  }
`

const CarouselWrapper = styled.div<{ $currentIndex: number }>`
  display: flex;
  transition: transform 0.5s ease;
  transform: ${(props: { $currentIndex: number }) => `translateX(-${props.$currentIndex * 100}%)`};
`

const Slide = styled.div`
  min-width: 100%;
  box-sizing: border-box;
`

const NavButton = styled.button<{ disabled: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  // background: ${p => p.theme.colors.carousel.navButtonBg};
  background: transparent;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 18px;
  z-index: 1;

  // &:hover {
  //   background: ${p => p.theme.colors.carousel.navButtonBgHover};
  // }

  & > svg {
    opacity: ${p => (p.disabled ? '0.25' : '1')};
  }
  &.prev {
    left: 10px;
  }

  &.next {
    right: 10px;
  }
`

const Navigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`

interface Props<T> {
  data: T[]
  renderItem: (item: T, index: number) => ReactNode
}

export const Carousel = <T,>({ data, renderItem }: Props<T>) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex === data.length - 1 ? 0 : prevIndex + 1))
  }

  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex === 0 ? data.length - 1 : prevIndex - 1))
  }

  return (
    <CarouselContainer>
      <CarouselWrapper $currentIndex={currentIndex}>
        {data.map((d, index) => (
          <Slide key={index}>{renderItem(d, index)}</Slide>
        ))}
      </CarouselWrapper>
      <NavButton className="prev" onClick={prevSlide} disabled={currentIndex === 0}>
        <IconLeft />
      </NavButton>
      <NavButton className="next" onClick={nextSlide} disabled={currentIndex === data.length - 1}>
        <IconRight />
      </NavButton>
      <Navigation>
        {data.map((_d, index) =>
          index === currentIndex ? <IconRadioButtonActive key={index} /> : <IconRadioButtonNotActive key={index} />
        )}
      </Navigation>
    </CarouselContainer>
  )
}
